// extracted by mini-css-extract-plugin
export var completionBody = "_md-2";
export var completionCard = "_md-0";
export var completionFooter = "_md-3";
export var completionTitle = "_md-1";